import type { useQueryClient } from '@tanstack/react-query';

import { getMeControllerObterQueryKey } from '@/api/generated/me/me';
import type { MeResponse } from '@/api/generated/model';
import { ApiError } from '@/api/http-client';
import { toast } from '@/shared/ui/sonner';

/**
 * Callbacks de toda mutação de perfil.
 *
 * Toda rota de arquivo e de assinatura do `/me` devolve o `MeResponse`
 * INTEIRO, então o cache recebe a resposta do servidor em vez de disparar um
 * GET extra. É a MESMA query do `AuthProvider`, que alimenta o header: a foto
 * nova aparece nos dois no mesmo instante.
 */
export function aoResponder(queryClient: ReturnType<typeof useQueryClient>, sucesso: string) {
  return {
    onSuccess: (atualizado: MeResponse) => {
      queryClient.setQueryData(getMeControllerObterQueryKey(), atualizado);
      toast.success(sucesso);
    },
    // A mensagem do servidor já diz a regra ("A imagem tem 1200×400 (3.00:1).
    // Esta posição exige 1:1 — por exemplo 800×800.", "Este certificado venceu
    // em 01/01/2021."). Reescrevê-la aqui criaria dois textos para divergir.
    onError: (erro: unknown) =>
      toast.error(erro instanceof ApiError ? erro.message : 'Não foi possível enviar o arquivo'),
  };
}
